/**
 *    SPDX-License-Identifier: Apache-2.0
 */

const namespaces = 'tables';

const BLOCK_LIST = `${namespaces}/BLOCK_LIST`;
const CHAINCODE_LIST = `${namespaces}/CHAINCODE_LIST`;
const CHANNELS = `${namespaces}/CHANNELS`;
const PEER_LIST = `${namespaces}/PEER_LIST`;
const TRANSACTION = `${namespaces}/TRANSACTION`;
const TRANSACTION_LIST = `${namespaces}/TRANSACTION_LIST`;
const BLOCK_LIST_SEARCH = `${namespaces}/BLOCK_LIST_SEARCH`;
const TRANSACTION_LIST_SEARCH = `${namespaces}/TRANSACTION_LIST_SEARCH`;
const ORGS = `${namespaces}/ORGS`;

export default {
  BLOCK_LIST,
  CHAINCODE_LIST,
  CHANNELS,
  PEER_LIST,
  TRANSACTION,
  TRANSACTION_LIST,
  BLOCK_LIST_SEARCH,
  TRANSACTION_LIST_SEARCH,
  ORGS,
};
